// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class MarkupData {
    constructor(typeId, formula, markups) {
        this.TypeId = typeId;
        this.Formula = formula;
        this.Markups = markups;
    }
    toString() {
        return this.TypeId.toString();
    }
}
